// @flow
import { SeaConfigActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    seaConfig: {},
    listaSeaConfigs: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type SeaConfigAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { seaConfig?: {} | null, listaSeaConfigs?: [] | null, loading?: boolean, +value ?: boolean };

const SeaConfig = (state: State = INIT_STATE, action: SeaConfigAction): any => {
    // console.log(action);
    switch (action.type) {
        case SeaConfigActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SeaConfigActionTypes.GET_SEA_CONFIG: {
                    return {
                        ...state,
                        seaConfig: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeaConfigActionTypes.LIST_SEA_CONFIGS: {
                    return {
                        ...state,
                        listaSeaConfigs: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case SeaConfigActionTypes.ADD_SEA_CONFIG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaConfigActionTypes.UPDATE_SEA_CONFIG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaConfigActionTypes.DELETE_SEA_CONFIG: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeaConfigActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SeaConfigActionTypes.GET_SEA_CONFIG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        seaConfig: {},
                        loading: false,
                    };
                }
                case SeaConfigActionTypes.LIST_SEA_CONFIGS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaSeaConfigs: [],
                        loading: false,
                    };
                }
                case SeaConfigActionTypes.ADD_SEA_CONFIG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaConfigActionTypes.UPDATE_SEA_CONFIG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case SeaConfigActionTypes.DELETE_SEA_CONFIG: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case SeaConfigActionTypes.GET_SEA_CONFIG:
            return { ...state, error: false, loading: true };
        case SeaConfigActionTypes.LIST_SEA_CONFIGS:
            return { ...state, error: false, loading: true };
        case SeaConfigActionTypes.ADD_SEA_CONFIG:
            return { ...state, error: false, loading: true };
        case SeaConfigActionTypes.UPDATE_SEA_CONFIG:
            return { ...state, error: false, loading: true };
        case SeaConfigActionTypes.DELETE_SEA_CONFIG:
            return { ...state, error: false, loading: true };
        case SeaConfigActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                seaConfig: {},
                listaSeaConfigs: [],
                formSubmited: false
            };
        case SeaConfigActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default SeaConfig;
